import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const testExecutionDefaultValues = { testCollection: '', workflowId: '' };

const testExecutionSchema = yup.object({
  testCollection: yup.string().required('Test Collection is required.'),
  workflowId: yup.string().required('Workflow Ticket ID is required.')
});

export function useTestExecutionForm() {
  return useForm<{ testCollection: string; workflowId: string }>({
    mode: 'onSubmit',
    resolver: yupResolver(testExecutionSchema),
    defaultValues: testExecutionDefaultValues
  });
}
